module.exports = __webpack_public_path__ + "media/images/ohap_welcome_pages_banner-a5e2cdff40ba38f8e034e2c739d26f2f.png";